import Vue from 'vue'

import { axiosRequest } from '@/plugins/axios-common'
import { handleError } from '@/store/handle-error'

export const ShortMessageTemplatesState = {
  shortMessageTemplates: [],
}

export const ShortMessageTemplatesActions = {
  getShortMessageTemplates: async ({ commit }) => {
    return axiosRequest.
      get('/short_messages/templates').
      then(({ data }) => commit('setShortMessageTemplates', data)).
      catch(handleError)
  },

  createShortMessageTemplate: async ({ commit }, template) => {
    return axiosRequest.
      post('/short_messages/templates', { short_message_template: template }).
      then(({ data }) => commit('setShortMessageTemplate', data)).
      catch(handleError)
  },

  updateShortMessageTemplate: async ({ commit }, template) => {
    return axiosRequest.
      patch(`/short_messages/templates/${template.id}`, { short_message_template: template }).
      then(({ data }) => commit('setShortMessageTemplate', data)).
      catch(handleError)
  },

  deleteShortMessageTemplate: async ({ commit }, templateId) => {
    return axiosRequest.
      delete(`/short_messages/templates/${templateId}`).
      then(_ => commit('removeShortMessageTemplate', templateId)).
      catch(handleError)
  },

  createShortMessageTemplateTranslation: async ({ commit }, { templateId, translation }) => {
    return axiosRequest.
      post(
        `/short_messages/templates/${templateId}/translations`,
        { short_message_template_translation: translation }
      ).
      then(({ data }) => commit('setShortMessageTemplateTranslation', data)).
      catch(handleError)
  },

  updateShortMessageTemplateTranslation: async ({ commit }, { templateId, translation }) => {
    return axiosRequest.
      patch(
        `/short_messages/templates/${templateId}/translations/${translation.id}`,
        { short_message_template_translation: translation }
      ).
      then(({ data }) => commit('setShortMessageTemplateTranslation', data)).
      catch(handleError)
  },

  deleteShortMessageTemplateTranslation: async ({ commit }, { templateId, translationId }) => {
    return axiosRequest.
      delete(`/short_messages/templates/${templateId}/translations/${translationId}`).
      then(_ => commit('removeShortMessageTemplateTranslation', { templateId, translationId })).
      catch(handleError)
  },
}

export const ShortMessageTemplatesMutations = {
  setShortMessageTemplates: (state, payload) => { state.shortMessageTemplates = payload },

  setShortMessageTemplate: (state, payload) => {
    const idx = state.shortMessageTemplates.findIndex(t => t.id === payload.id)

    if (idx < 0) state.shortMessageTemplates.push(payload)
    else Vue.set(state.shortMessageTemplates, idx, payload)
  },

  removeShortMessageTemplate: (state, templateId) => {
    const idx = state.shortMessageTemplates.findIndex(t => t.id === templateId)
    if (idx < 0) return

    state.shortMessageTemplates.splice(idx, 1)
  },

  setShortMessageTemplateTranslation: (state, payload) => {
    const template = state.shortMessageTemplates.find(t => t.id === payload.short_message_template_id)
    if (!template) return

    const idx = template.short_message_template_translations.findIndex(t => t.id === payload.id)
    if (idx < 0) template.short_message_template_translations.push(payload)
    else Vue.set(template.short_message_template_translations, idx, payload)
  },

  removeShortMessageTemplateTranslation: (state, { templateId, translationId }) => {
    const template = state.shortMessageTemplates.find(t => t.id === templateId)
    if (!template) return

    const idx = template.short_message_template_translations.findIndex(t => t.id === translationId)
    if (idx < 0) return

    template.short_message_template_translations.splice(idx, 1)
  },
}

export const ShortMessageTemplatesGetters = {
  shortMessageTemplates: state => state.shortMessageTemplates,

  shortMessageTemplateTranslations: (state, templateId) => {
    return state.shortMessageTemplates.
      find(t => t.id === templateId)?.
      short_message_template_translations
  },
}
